(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/tipssm.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/tipssm.js'); "use strict";


var tipsSMEl;

var getContainer = function getContainer() {
  return tipsSMEl;
};

var render = function render() {
  svs.core.module.load('/cl/sport/tipssm', null, function () {
    var _ReactRedux = ReactRedux,
        Provider = _ReactRedux.Provider;
    var _svs$components$sport = svs.components.sport.tipssm,
        TipsSM = _svs$components$sport.TipsSM,
        createStore = _svs$components$sport.createStore;
    createStore(function () {
      var store = svs.components.sport.tipssm.store; 

      tipsSMEl = document.querySelector('.js-tabs-content .slider-slide-active'); 

      ReactDOM.render( React.createElement(Provider, {
        store: store
      }, React.createElement(TipsSM, null)), tipsSMEl);
    });
  });
};

svs.tipset.tipssm = {
  render: render,
  getContainer: getContainer
};
 })(window);